/**
 * The one place that says how long a password has to be.
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * WHY THIS EXISTS
 * ─────────────────────────────────────────────────────────────────────────────
 *
 * There were three different minimums for one rule:
 *
 *   · the set-password screen refused under 10
 *   · the profile screen refused under 8
 *   · the API accepts 8, which is GoTrue's own floor
 *
 * So a nine-character password was accepted in one place, refused in another, and would
 * have been accepted by the server in both. That is not a stricter policy — it is a screen
 * disagreeing with the system it is a front for, which produces a refusal the reader cannot
 * explain and cannot appeal.
 *
 * EIGHT, not ten. The API deliberately does not raise GoTrue's floor: a second, stricter
 * rule in front of the identity provider rejects passwords the provider accepts, and the
 * user is then told their password is invalid by a service that does not own the rule, with
 * no way to discover which of the two refused it. The screens must not reintroduce that
 * from the other side.
 *
 * ADVICE IS NOT A FLOOR. The strength meter still says ten-plus and still calls a short
 * password weak — guidance is free, and it is what actually moves people. What it must not
 * do is block a password the server will accept.
 */

/** The minimum this product enforces, matching GoTrue's floor and the API's Zod schema. */
export const PASSWORD_MIN_LENGTH = 8;

/** Where the strength meter stops calling a password short. Guidance, not a gate. */
export const PASSWORD_COMFORTABLE_LENGTH = 12;
